import { closeSubMenus } from './closeSubMenus';

const searchModules = document.querySelectorAll('.search-module');
const hasSearchModules = searchModules.length > 0;

const desktopSearch = document.querySelector('.header__bottom-search');
const mobileSearch = document.querySelector('.header__small__search');

if (hasSearchModules) {
  searchModules.forEach((searchModule) => {
    const searchIcon = searchModule.querySelector('.search-module__icon');

    searchIcon.addEventListener('click', () => {
      closeSubMenus();

      if (searchModule.classList.contains('is-active')) {
        closeAllSearch();
      } else {
        showSearch(searchModule);
      }
    });
  });

  document.addEventListener('scroll', () => {
    const hasSearchModule = Boolean(document.querySelector('.search-module.is-active'));
    if (hasSearchModule) {
      closeAllSearch();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllSearch();
    }
  });

  document.addEventListener('click', ({ target }) => {
    const clickedOutsideSearch = !desktopSearch.contains(target) && !mobileSearch.contains(target);

    if (clickedOutsideSearch) {
      closeAllSearch();
    }
  });
}

function closeAllSearch() {
  const searchModules = document.querySelectorAll('.search-module');

  searchModules.forEach((searchModule) => {
    searchModule.classList.remove('is-active');
  });
}

function showSearch(searchModule) {
  if (!searchModule) {
    return;
  }

  const searchInput = searchModule.querySelector("input[type='search']");
  searchModule.classList.add('is-active');
  window.setTimeout(() => {
    searchInput.focus();
  }, 50);
}

export { closeAllSearch };

const searches = document.querySelectorAll('.search-module');
searches.forEach((search) => {
  const input = search.querySelector('.search-module__search-input');
  const button = search.querySelector('.search-module__submit');

  if (input && button) {
    function updateInputState() {
      if (input.value.trim() !== '') {
        button.classList.add('search-module__submit--value');
      } else {
        button.classList.remove('search-module__submit--value');
      }
    }

    input.addEventListener('input', updateInputState);
    updateInputState();
  }
});
